module.exports = __webpack_public_path__ + "static/media/shuklaNVPH3.115dd1d3.webp";